






import { Vue, Component } from "vue-property-decorator";
import DiabetesRiskMain from "@/components/DiabetesRiskMain.vue";

@Component({
  components: {
    DiabetesRiskMain,
  },
})
export default class AppVue extends Vue {
  created() {
    document.title =
      "日本人2型糖尿病患者における合併症リスク評価（JJリスクエンジン）";
  }
}
